import React, { useState, useEffect } from "react";
import avatar from "../assets/imgs/new/avatar.png";
import { useDispatch, useSelector } from "react-redux";
import { getUsers } from "../redux/actions/user.action";
import { getAllMemoirs } from "../redux/actions/memoir.action";
import Avatar from "react-avatar";
import moment from "moment";
import {
  addQuantity,
  addToCart,
  removeFromCart,
  subQuantity,
} from "../redux/actions/orderqrcart.actions";
import QRCode from "qrcode.react";
import polygon from "../assets/imgs/polygon.png";

import {
  Button,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Spinner,
  Modal,
  ModalBody,
} from "reactstrap";
import {
  getNotifications,
  readSingleNotification,
  readAllNotifications,
  deleteNotification,
} from "../redux/actions/notification.action";
import Checkout from "./Modals/Checkout";
import { useHistory } from "react-router-dom";

function MainHeader({ heading }) {
  const history = useHistory();
  let total = 0;
  let cartTotal = 0;
  const { profile_image, id } = useSelector((state) => state.authUser);
  const [notificationDropDown, setNotificationDropDown] = useState(false);
  const { allMemoirs } = useSelector((state) => state.memoir);
  const { users } = useSelector((state) => state.user);
  const { qr_list } = useSelector((state) => state.orderQrCart);
  const qrCodesBGColors = ["#DBC3A6", "#FBBB00", "#FF4B55"];

  const { notifications, loading } = useSelector((state) => state.notification);
  const dispatch = useDispatch();
  const [cartModal, setCartModal] = useState(false);
  const [checkOut, setCheckOut] = useState(false);
  const checkOutToggle = () => {
    setCheckOut(!checkOut);
  };
  const toggleModal = () => {
    setCartModal(!cartModal);
  };

  const getUserDetails = (id) => {
    if (id != undefined) {
      let obj = users.length > 0 && users.find((user) => user.id == id);
      if (obj != null) {
        return obj;
      } else {
        return "N/A";
      }
    } else {
      return "N/A";
    }
  };
  const getMemoirDetails = (id) => {
    if (id != undefined) {
      let obj =
        allMemoirs.length > 0 && allMemoirs.find((memoir) => memoir.id == id);
      if (obj != null) {
        return obj;
      } else {
        return "N/A";
      }
    } else {
      return "N/A";
    }
  };

  const getNewNotifications = () => {
    if (notifications && notifications.length > 0) {
      let notification = notifications.filter((noti) => {
        if (!noti.read) {
          return noti;
        }
      });

      return notification.length;
    } else {
      return 0;
    }
  };

  useEffect(() => {
    if (id && notifications && notifications.length == 0) {
      dispatch(getNotifications(id));
    }
    if (users.length == 0) {
      dispatch(getUsers());
    }
    if (allMemoirs.length == 0) {
      dispatch(getAllMemoirs());
    }
  }, []);

  const notificationToggle = () => {
    setNotificationDropDown(!notificationDropDown);
  };

  const getActionBtn = (read, id) => {
    if (!read) {
      return (
        <div
          className="ml-auto unread_notifications d-flex justify-content-center align-items-center"
          onClick={(e) => {
            dispatch(readSingleNotification(id));
          }}
        >
          1
        </div>

        // <Button
        // 	className='ml-auto px-2 rounded-circle read-btn text-success'
        // 	size='sm'
        // 	onClick={e => {
        // 		dispatch(readSingleNotification(id));
        // 	}}
        // >
        // 	<i class='fas fa-check'></i>
        // </Button>
      );
    } else {
      return (
        <div
          className="ml-auto unread_notifications d-flex justify-content-center align-items-center"
          onClick={(e) => {
            dispatch(deleteNotification(id));
          }}
        >
          <i class="fa fa-close"></i>
        </div>
        // <Button
        // 	className='ml-auto px-2 rounded-circle close-btn text-danger'
        // 	size='sm'
        // 	onClick={e => {
        // 		dispatch(deleteNotification(id));
        // 	}}
        // >
        // 	<i class='fa fa-close'></i>
        // </Button>
      );
    }
  };

  return (
    <div className="d-flex align-items-center">
      <Checkout isOpen={checkOut} checkOutToggle={checkOutToggle} />
      <h2 className="font-weight-bold text-uppercase">{heading}</h2>
      <div className="d-flex align-items-center ml-auto">
        <span className="mr-4">
          {qr_list && qr_list.length > 0 && (
            <i
              className="fa fa-shopping-cart mr-3 pointer"
              onClick={() => toggleModal()}
            >
              <sup>{qr_list.length}</sup>
            </i>
          )}
        </span>
        <Dropdown isOpen={notificationDropDown} toggle={notificationToggle}>
          <DropdownToggle className="bg-transparent p-0 toggle-btn">
            <i className="fa fa-bell mr-3 pointer">
              {notifications.length >0?(<sup>{getNewNotifications()}</sup>):('')}
              
            </i>
          </DropdownToggle>
          <DropdownMenu right className="px-2 notification_menu">
            <img src={polygon} className="notifications__dropdown" />
            <div className="d-flex justify-content-center align-items-center">
              <p className="notifications__heading py-4">NOTIFICATIONS</p>
              {/* <Button
								className='read-all-btn ml-auto'
								size='sm'
								onClick={() => {
									if (
										notifications &&
										notifications.length > 0
									) {
										dispatch(
											readAllNotifications(notifications)
										);
									}
								}}
								disabled={loading}
							>
								{loading ? (
									<Spinner size='sm' />
								) : (
									' Mark all as read'
								)}
							</Button> */}
            </div>

            {/* <hr /> */}

            {/* <div className='d-flex px-3 justify-content-center align-items-center notifcation_item'>
							<Avatar
								round={true}
								className='notifications_profile_image'
								src={profile_image}
								size={65}
							/>
							<div className='px-3'>
								<p className='notification_text'>
									List has sent you a request to have
									permission to view “Birthday” Memoir
								</p>
								<span className='notification_sub_text'>
									1m ago
								</span>
							</div>
							<div className='ml-auto unread_notifications d-flex justify-content-center align-items-center'>
								2
							</div>
						</div> */}

            <div className="custom__notification__menu">
              {notifications && notifications.length > 0 ? (
                notifications.map((noti) => {
                  if (noti.type == "collab") {
                    if (noti.status == "invited") {
                      return (
                        <div
                          className="d-flex my-2 px-1 px-md-3 justify-content-center align-items-start notifcation_item"
                          onClick={() => {
                            dispatch(readSingleNotification(noti.id));
                            history.push("/dashboard/collaboratives");
                          }}
                        >
                          <div>
                            <Avatar
                              round={true}
                              className="notifications_profile_image"
                              src={getUserDetails(noti.user_id).profile_image}
                              size={40}
                              // width={50}
                              // height={37}
                            />
                          </div>
                          <div className="px-1 px-md-3">
                            <p className="notification_text">
                              {getUserDetails(noti.user_id).firstname} invited
                              you to there memoir{" "}
                              {getMemoirDetails(noti.memoir_id) != "N/A" ? (
                                <>
                                  {
                                    getMemoirDetails(noti.memoir_id)
                                      .memoir_title
                                  }
                                </>
                              ) : (
                                "N/A"
                              )}
                            </p>
                            <span className="notification_sub_text">
                              {moment.unix(noti.created_at.seconds).fromNow()}
                            </span>
                          </div>
                          {getActionBtn(noti.read, noti.id)}
                        </div>

                        // <div className='d-flex m-0 p-1'>
                        // 	<span className='text-nowrap m-1'>
                        // 		{
                        // 			getUserDetails(
                        // 				noti.user_id
                        // 			).firstname
                        // 		}{' '}
                        // 		invited you to there
                        // 		memoir{' '}
                        // 		{getMemoirDetails(
                        // 			noti.memoir_id
                        // 		) != 'N/A' ? (
                        // 			<>
                        // 				{
                        // 					getMemoirDetails(
                        // 						noti.memoir_id
                        // 					)
                        // 						.memoir_title
                        // 				}
                        // 			</>
                        // 		) : (
                        // 			'N/A'
                        // 		)}
                        // 	</span>
                        // 	{getActionBtn(
                        // 		noti.read,
                        // 		noti.id
                        // 	)}
                        // </div>
                      );
                    } else if (noti.status == "accepted") {
                      return (
                        <div
                          className="d-flex my-2 px-1 px-md-3 justify-content-center align-items-start notifcation_item"
                          onClick={() => {
                            dispatch(readSingleNotification(noti.id));
                          }}
                        >
                          <div>
                            <Avatar
                              round={true}
                              className="notifications_profile_image"
                              src={getUserDetails(noti.user_id).profile_image}
                              size={40}
                            />
                          </div>
                          <div className="px-1 px-md-3">
                            <p className="notification_text">
                              {getUserDetails(noti.user_id).firstname} accepted
                              your request to join memoir{" "}
                              {getMemoirDetails(noti.memoir_id) != "N/A" ? (
                                <>
                                  {
                                    getMemoirDetails(noti.memoir_id)
                                      .memoir_title
                                  }
                                </>
                              ) : (
                                "N/A"
                              )}
                            </p>
                            <span className="notification_sub_text">
                              {moment.unix(noti.created_at.seconds).fromNow()}
                            </span>
                          </div>
                          {getActionBtn(noti.read, noti.id)}
                        </div>
                        // <div className='d-flex m-0 p-1'>
                        // 	<span className='text-nowrap m-1'>
                        // 		{
                        // 			getUserDetails(
                        // 				noti.user_id
                        // 			).firstname
                        // 		}{' '}
                        // 		accepted your request to
                        // 		join memoir{' '}
                        // 		{getMemoirDetails(
                        // 			noti.memoir_id
                        // 		) != 'N/A' ? (
                        // 			<>
                        // 				{
                        // 					getMemoirDetails(
                        // 						noti.memoir_id
                        // 					)
                        // 						.memoir_title
                        // 				}
                        // 			</>
                        // 		) : (
                        // 			'N/A'
                        // 		)}
                        // 	</span>

                        // 	{getActionBtn(
                        // 		noti.read,
                        // 		noti.id
                        // 	)}
                        // </div>
                      );
                    } else if (noti.status == "requested") {
                      return (
                        <div
                          className="d-flex my-2 px-1 px-md-3 justify-content-center align-items-start notifcation_item"
                          onClick={() => {
                            dispatch(readSingleNotification(noti.id));
                          }}
                        >
                          <div>
                            <Avatar
                              round={true}
                              className="notifications_profile_image"
                              src={getUserDetails(noti.user_id).profile_image}
                              size={40}
                            />
                          </div>

                          <div className="px-1 px-md-3">
                            <p className="notification_text">
                              {getUserDetails(noti.user_id).firstname} requested
                              to join your memoir{" "}
                              {getMemoirDetails(noti.memoir_id) != "N/A" ? (
                                <>
                                  {
                                    getMemoirDetails(noti.memoir_id)
                                      .memoir_title
                                  }
                                </>
                              ) : (
                                "N/A"
                              )}
                            </p>
                            <span className="notification_sub_text">
                              {moment.unix(noti.created_at.seconds).fromNow()}
                            </span>
                          </div>
                          {getActionBtn(noti.read, noti.id)}
                        </div>
                        // <div className='d-flex m-0 p-1'>
                        // 	<span className='text-nowrap m-1'>
                        // 		{
                        // 			getUserDetails(
                        // 				noti.user_id
                        // 			).firstname
                        // 		}{' '}
                        // 		requested to join your
                        // 		memoir{' '}
                        // 		{getMemoirDetails(
                        // 			noti.memoir_id
                        // 		) != 'N/A' ? (
                        // 			<>
                        // 				{
                        // 					getMemoirDetails(
                        // 						noti.memoir_id
                        // 					)
                        // 						.memoir_title
                        // 				}
                        // 			</>
                        // 		) : (
                        // 			'N/A'
                        // 		)}
                        // 	</span>
                        // 	{getActionBtn(
                        // 		noti.read,
                        // 		noti.id
                        // 	)}
                        // </div>
                      );
                    }
                  } else if (noti.type == "order") {
                    if (noti.status == "placed") {
                      return (
                        <div
                          className="d-flex my-2 px-1 px-md-3 justify-content-center align-items-start notifcation_item"
                          onClick={() => {
                            dispatch(readSingleNotification(noti.id));
                          }}
                        >
                          <div>
                            <Avatar
                              round={true}
                              className="notifications_profile_image"
                              src={getUserDetails(noti.user_id).profile_image}
                              size={40}
                            />
                          </div>
                          <div className="px-1 px-md-3">
                            <p className="notification_text">
                              Your order has been placed
                            </p>
                            <span className="notification_sub_text">
                              {/* {getTimeDefference(
																moment().toDate(),
																noti.created_at
															)} */}
                              {moment.unix(noti.created_at.seconds).fromNow()}
                            </span>
                          </div>
                          {getActionBtn(noti.read, noti.id)}
                        </div>
                        // <div className='d-flex m-0 p-1'>
                        // 	<span className='text-nowrap m-1'>
                        // 		Your order has been
                        // 		placed
                        // 	</span>
                        // 	{getActionBtn(
                        // 		noti.read,
                        // 		noti.id
                        // 	)}
                        // </div>
                      );
                    } else {
                      return (
                        <div
                          className="d-flex my-2 px-1 px-md-3 justify-content-center align-items-start notifcation_item"
                          onClick={() => {
                            dispatch(readSingleNotification(noti.id));
                          }}
                        >
                          <div>
                            <Avatar
                              round={true}
                              className="notifications_profile_image"
                              src={getUserDetails(noti.user_id).profile_image}
                              size={40}
                            />
                          </div>
                          <div className="px-1 px-md-3">
                            <p className="notification_text">
                              Your order with order id (
                              {noti.order_id ? noti.order_id : "N/A"}) is{" "}
                              {noti.status ? noti.status : "N/A"}
                            </p>
                            <span className="notification_sub_text">
                              {moment.unix(noti.created_at.seconds).fromNow()}
                            </span>
                          </div>
                          {getActionBtn(noti.read, noti.id)}
                        </div>
                        // <div className='d-flex m-0 p-1'>
                        // 	<span className='text-nowrap m-1'>
                        // 		Your order with order
                        // 		id(
                        // 		{noti.order_id
                        // 			? noti.order_id
                        // 			: 'N/A'}
                        // 		) is{' '}
                        // 		{noti.status
                        // 			? noti.status
                        // 			: 'N/A'}
                        // 	</span>
                        // 	{getActionBtn(
                        // 		noti.read,
                        // 		noti.id
                        // 	)}
                        // </div>
                      );
                    }
                  }
                })
              ) : (
                <div className="d-flex justify-content-center">
                  <p className="notification_text">
                    You don't have any notification
                  </p>
                </div>
              )}
            </div>
          </DropdownMenu>
        </Dropdown>

        {/* <i className="fa fa-bell mr-3 pointer">
          <sup>0</sup>
        </i> */}

        {/* <span className="mr-4">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5C21 3.34 19.66 2 18 2C16.34 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.35C15.11 18.56 15.08 18.78 15.08 19C15.08 20.61 16.39 21.92 18 21.92C19.61 21.92 20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08Z"
              fill="black"
            />
          </svg>
        </span> */}
        <div className="d-flex align-items-center">
          <Avatar
            round={true}
            className="memoir_no_display_img"
            src={profile_image}
            size={48}
          />
        </div>
      </div>

      {/* Cart Modal */}

      <Modal isOpen={cartModal}>
        <ModalBody className="p-0">
          <div className="cart">
            <div className="text-right">
              <i
                className="fa fa-times text-danger pointer m-3"
                onClick={() => toggleModal()}
              ></i>
            </div>
            <div className="modal-content-wrapper ">
              <h5 className="font-weight-bold">My Shopping Cart</h5>
              <div className="cart-item">
                <div className="cart-cols  f-12 text-muted">
                  <span>Product:</span>
                  <span className="text-center">Quantity</span>
                  <span className="text-center">Price</span>
                  <span className="text-center">Action</span>
                </div>
                {qr_list &&
                  qr_list.map((qr_cart, index) => {
                    cartTotal = cartTotal + qr_cart.price * qr_cart.qty;
                    return (
                      <Cart
                        dispatch={dispatch}
                        key={index}
                        qr_cart={qr_cart}
                        qrCodesBGColors={qrCodesBGColors}
                        getMemoirDetails={getMemoirDetails}
                      />
                    );
                  })}
                <div
                  style={{
                    borderTop: "1px solid #00000040",
                  }}
                  className="mt-4 d-flex"
                >
                  <Button
                    className="btn-outline mt-2 dashboard-btn"
                    onClick={() => {
                      toggleModal();
                      checkOutToggle();
                    }}
                  >
                    Proceed to Checkout
                  </Button>
                  <h6 className="ml-auto mt-4 font-weight-bold">
                    Total:{" "}
                    <span
                      style={{
                        color: "#D93D13",
                      }}
                    >
                      £{cartTotal.toFixed(2)}
                    </span>
                  </h6>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
}

const Cart = (props) => {
  let { qr_cart, qrCodesBGColors, getMemoirDetails, dispatch } = props;
  return (
    <>
      <div className="cart-cols header pt-2">
        <span>
          <span className="d-flex align-items-center">
            <div
              className="p-1 m-0 text-center"
              style={{
                backgroundColor: qrCodesBGColors[qr_cart.template],
                width: 74,
                height: 74,
              }}
            >
              <QRCode
                value={qr_cart.qrValue}
                bgColor={qrCodesBGColors[qr_cart.template]}
                fgColor="#484E9C"
                size={64}
              />
              {/* <img
                              src={qrCode1}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            /> */}
            </div>
            <div className="ml-2 f-14">
              <small className="d-block font-weight-bold">QR Code</small>
              <small className="d-block f-12">ID: {qr_cart.qrID}</small>
              <small className="d-block font-weight-bold">
                Material: {qr_cart.material}
              </small>
            </div>
          </span>

          <small className="font-weight-bold f-12">
            {getMemoirDetails(qr_cart.memoirID).memoir_title}
          </small>
          <br />
          <small
            style={{
              fontSize: 10,
            }}
            className="d-flex flex-column"
          >
            <span>Top Text: {qr_cart.topText}</span>
            <span>Bottom Text: {qr_cart.bottomText}</span>
            <span>Template: {qr_cart.template + 1}</span>
          </small>
        </span>
        <span className="text-center">
          <div className="counter ml-auto d-flex align-items-center">
            <button
              className="qt-control font-weight-bold border-0"
              disabled={qr_cart.qty <= 1}
              onClick={() => {
                dispatch(subQuantity(qr_cart.memoirID));
              }}
            >
              -
            </button>
            <span className="f-14 font-weight-bold">{qr_cart.qty}</span>
            <button
              className="qt-control font-weight-bold border-0"
              onClick={() => {
                dispatch(addQuantity(qr_cart.memoirID));
              }}
            >
              +
            </button>
          </div>
        </span>
        <span className="text-center">
          <small className="font-weight-bold">
            £{(qr_cart.qty * qr_cart.price).toFixed(2)}
          </small>
        </span>
        <span className="text-center">
          <small className="font-weight-bold">
            <i
              className="fa fa-trash pointer text-danger"
              onClick={() => {
                dispatch(removeFromCart(qr_cart.memoirID));
              }}
            ></i>
          </small>
        </span>
      </div>
    </>
  );
};

export default MainHeader;
